import { useEffect, useState } from "react";
import { UpcomingEventModel } from "../models/Event";
import { fetchAPI } from "../Helpers/utils";
import $ from "jquery";
import Foundation from "foundation-sites";
import UpcomingEventItems from "./EventItems";

export type UpcomingEventsSidebarModel = {
  source: number,
  numberOfMonths: number
}

export default function UpcomingEventsSidebar({source, numberOfMonths}: UpcomingEventsSidebarModel) {
  const [events, setEvents] = useState<UpcomingEventModel[]>([]);

  useEffect(() => {
    async function getData() {
      const data = await fetchAPI<UpcomingEventModel[]>(`/api/event/${source}/upcoming?numberOfMonths=${numberOfMonths}`);
      setEvents(data);
    };

    getData();
  }, [source, numberOfMonths]);

  useEffect(() => {
    new Foundation.Accordion($('.accordion'));
  }, [events])

  return (
    <div className="upcoming-events-sidebar">
      <div className="title"><h6>Upcoming</h6></div>
      <ul className="accordion" data-accordion data-allow-all-closed="true">
        <>
          {events.length > 0 && events.map((event, index) => {
            return (
              <li key={`group-${index}`} className="accordion-item" data-accordion-item>
                <a href="#" className="accordion-title">{event.groupName}</a>
                <div className="accordion-content" data-tab-content>
                  <UpcomingEventItems nodes={event.events} />
                </div>
              </li>
            )
          })}
        </>
      </ul>
    </div>
  )
}